import React, { createContext, useContext, useMemo, useReducer } from 'react';

import { createEmptyGraphState, graphReducer, normalizeGraphState } from './graphModel';

const GraphStateContext = createContext(null);

export const GraphStateProvider = ({ children, initialState }) => {
  const [graphState, dispatchGraph] = useReducer(
    graphReducer,
    initialState || createEmptyGraphState(),
    normalizeGraphState,
  );

  const value = useMemo(
    () => ({
      graphState,
      dispatchGraph,
    }),
    [graphState],
  );

  return <GraphStateContext.Provider value={value}>{children}</GraphStateContext.Provider>;
};

export const useGraphState = () => {
  const context = useContext(GraphStateContext);
  if (!context) {
    throw new Error('useGraphState must be used inside a GraphStateProvider.');
  }
  return context;
};
